'use client'

import { useEffect } from 'react'
import { usePathname, useSearchParams } from 'next/navigation'
export default function PageChangeNotifier() {
	const pathName = usePathname()
	const searchParams = useSearchParams()

	useEffect(() => {
		const newPath = `${pathName}${searchParams.toString() ? `?${searchParams.toString()}` : ''}`
		window.parent.postMessage({ type: 'iframe-url-change', path: newPath }, '*')
	}, [pathName, searchParams])

	return null
}
